import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts'

import type { DepartmentDistribution } from '@/hooks'

// 图表颜色
const COLORS = [
  '#3B82F6', // blue
  '#10B981', // green
  '#F59E0B', // amber
  '#EF4444', // red
  '#8B5CF6', // purple
  '#EC4899', // pink
  '#06B6D4', // cyan
  '#84CC16', // lime
  '#F97316', // orange
  '#6366F1', // indigo
]

interface DepartmentPieChartProps {
  data: DepartmentDistribution[]
  onSegmentClick?: (departmentId: string) => void
}

export function DepartmentPieChart({ data, onSegmentClick }: DepartmentPieChartProps) {
  if (data.length === 0) {
    return (
      <div className="text-muted-foreground flex h-[300px] items-center justify-center">
        暂无数据
      </div>
    )
  }

  const chartData = data.map((item, index) => ({
    ...item,
    name: item.departmentName,
    value: item.employeeCount,
    color: COLORS[index % COLORS.length],
  }))

  const handleClick = (entry: (typeof chartData)[0]) => {
    if (onSegmentClick) {
      onSegmentClick(entry.departmentId)
    }
  }

  return (
    <div className="h-[300px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={100}
            paddingAngle={2}
            dataKey="value"
            onClick={(_, index) => handleClick(chartData[index])}
            style={{ cursor: onSegmentClick ? 'pointer' : 'default' }}
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            content={({ active, payload }: { active?: boolean; payload?: any }) => {
              if (active && payload && payload.length) {
                const data = payload[0].payload as (typeof chartData)[0]
                return (
                  <div className="bg-background rounded-lg border p-3 shadow-lg">
                    <p className="font-medium">{data.departmentName}</p>
                    <p className="text-muted-foreground text-sm">员工数: {data.employeeCount} 人</p>
                    <p className="text-muted-foreground text-sm">占比: {data.percentage}%</p>
                  </div>
                )
              }
              return null
            }}
          />
          <Legend
            layout="vertical"
            align="right"
            verticalAlign="middle"
            formatter={(value, _entry) => {
              const data = chartData.find((d) => d.name === value)
              return (
                <span className="text-sm">
                  {value} ({data?.percentage}%)
                </span>
              )
            }}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  )
}
